import React from "react";

const SVGCopyClipboard = (
    <svg width="20" height="23" viewBox="0 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4 10.5C4 7.672 4 6.257 4.879 5.379C5.757 4.5 7.172 4.5 10 4.5H13C15.828 4.5 17.243 4.5 18.121 5.379C19 6.257 19 7.672 19 10.5V15.5C19 18.328 19 19.743 18.121 20.621C17.243 21.5 15.828 21.5 13 21.5H10C7.172 21.5 5.757 21.5 4.879 20.621C4 19.743 4 18.328 4 15.5V10.5Z"
            stroke="#DADADA" strokeWidth="1.5"/>
        <path
            d="M4 18.5C3.20435 18.5 2.44129 18.1839 1.87868 17.6213C1.31607 17.0587 1 16.2956 1 15.5V9.5C1 5.729 1 3.843 2.172 2.672C3.344 1.501 5.229 1.5 9 1.5H13C13.7956 1.5 14.5587 1.81607 15.1213 2.37868C15.6839 2.94129 16 3.70435 16 4.5"
            stroke="#DADADA" strokeWidth="1.5"/>
    </svg>
)

export default SVGCopyClipboard